import { ExpandableIconRoot as ExpandableIcon } from "./ExpandableIcon.styles";

export interface ExpandableIconProps {
    open: boolean;
}

export default ExpandableIcon;
